export default "__VITE_ASSET__CQMX4b1V__$_?nuxt_component=async&nuxt_component_name=IconFooterSecurityHandelsverbandAt&nuxt_component_export=default__"